import React, { useState, useEffect } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import { useLocation } from "react-router-dom";

function TicketListDropDownOption(props) {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const ticketPaths = [
      "/trouble-ticket/all-ticket-list",
      "/proactive-ticket-list" 
    ];
  
    const isInsideTickets = ticketPaths.some(path =>
      location.pathname.startsWith(path)
    );
  
    if (!isInsideTickets) {
      setSelectedItem(null);   
    }
  }, [location.pathname]);

  return (
    <div className={props.className}>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="link" className="p-0">
          <div style={{ display: "inline-block", textDecoration: "none", color: "inherit" }}>Ticket List</div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-right">
        {props.buttons.map((button, i) => (
          <DropdownItem
            key={i}
            active={selectedItem === i}
            onClick={() => {
              setSelectedItem(i);
              button.action();
            }}
          >
            {button.name}
          </DropdownItem>
        ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}

export default TicketListDropDownOption;